<div
	*ngIf="comegoEnabled$ | async"
	class="flex flex-col items-center justify-end gap-3"
>
	<div class="flex items-end justify-end space-x-2">
		@if (switchEnabled() === true) {
		<div class="mb-2 flex items-center space-x-2">
			<button
				(click)="onSwitch.emit('project')"
				[disabled]="(loading$.value$ | async)"
				[matTooltip]="'Swap to project times'"
				color="light"
				mat-icon-button
				mat-raised-button
				matTooltipPosition="left"
			>
				<mat-icon>swap_horizontal</mat-icon>
			</button>
		</div>
		}
		<div class="flex flex-col items-center justify-end gap-3">
			@if ( { comego: canAdd$.value$ | async, absence: workspace$canCreateAbsences | async}; as permission) {
			@if(permission.comego || permission.absence) {
			<button
				(click)="openCreateDialog(permission.comego ? 'default' : 'absence')"
				[disabled]="loading$.value$ | async"
				[matTooltip]=" '+ ' + (( permission.comego ? 'comego.workingtime' : 'comego.createAbsence') | translate )"
				mat-icon-button
				mat-raised-button
			>
				<mat-icon>add</mat-icon>
			</button>
			} }
			<ng-container *ngIf="this.comegoRunning$.value$ | async as tr">
				<button
					(click)="delete(tr.id, confirmDeleteDialog)"
					[disabled]="loading$.value$ | async"
					[matTooltip]="'comego.delete' | translate"
					class="bg-gray-50 text-red-500"
					mat-icon-button
					mat-raised-button
					matTooltipPosition="left"
				>
					<mat-icon>delete</mat-icon>
				</button>
				<button
					(click)="pause(tr.id)"
					[disabled]="(loading$.value$ | async) || (actionCooldown$ | async)"
					[matTooltipTemplate]="tooltipContinueRecording"
					[matTooltipTemplateContext]="{ type: 'work', time: (running$ | async) }"
					*ngIf="tr.type === 'work'"
					color="light"
					mat-icon-button
					mat-raised-button
					matTooltip
					matTooltipPosition="left"
					matTooltipPosition="left"
				>
					<mat-icon>pause</mat-icon>
				</button>
				<button
					(click)="resume(tr.id)"
					[disabled]="(loading$.value$ | async) || (actionCooldown$ | async)"
					[matTooltipTemplate]="tooltipContinueRecording"
					[matTooltipTemplateContext]="{ type: 'pause', time: (running$ | async) }"
					*ngIf="tr.type === 'pause'"
					color="light"
					mat-icon-button
					mat-raised-button
					matTooltip
					matTooltipPosition="left"
					matTooltipPosition="left"
				>
					<mat-icon>not_started</mat-icon>
				</button>
			</ng-container>
			<ng-container
				*ngTemplateOutlet="
          (loading$.value$ | async) ? loadingFab : normalFabTimer;
          context: { time: (running$ | async) }
        "
			></ng-container>
		</div>
	</div>
	<ng-template
		#normalFabTimer
		let-status
		let-time="time"
	>
		<ng-container *ngIf="{ ho: hasOverlappingEntry$ | async, dr: disableRecording | async } as ci">
			<span
				[matTooltip]="
					!time && ci.ho ? ('comego.checkInBlockedByExistingEntry' | translate) : ci.dr ? ('comego.recordingEnabledIn' | translate: { date: disabledUntil.value }) : ''
				"
			>
				<button
					(click)="time ? stopRecord() : startRecord()"
					[disabled]="(disableRecording | async) || (!time && (hasOverlappingEntry$ | async)) || (isSameMinute$ | async)"
					[matTooltipTemplate]="tooltipCounter"
					[matTooltipTemplateContext]="{ time: time }"
					[ngClass]="{
            '!bg-red-500 disabled:!bg-red-500/60 text-white': time,
            '!bg-green-600 disabled:!bg-green-600/60 text-white': !time,
          }"
					fxHide.lt-lg
					mat-fab
					matTooltip
					matTooltipPosition="left"
				>
					<mat-icon *ngIf="!time; else runningTime">login</mat-icon>
					<ng-template #runningTime> <mat-icon>logout</mat-icon> </ng-template>
				</button>
			</span>
		</ng-container>
		<ng-container *ngIf="{ ho: hasOverlappingEntry$ | async, dr: disableRecording | async } as ci2">
			<div
				[matTooltip]="
					!time && ci2.ho ? ('comego.checkInBlockedByExistingEntry' | translate) : ci2.dr ? ('comego.recordingEnabledIn' | translate: { date: disabledUntil.value }) : ''
				"
				class="relative"
				fxHide.gt-md
			>
				<button
					(click)="time ? stopRecord() : startRecord()"
					[disabled]="(disableRecording | async) || (!time && (hasOverlappingEntry$ | async)) || (isSameMinute$ | async)"
					[matTooltipTemplate]="tooltipCounter"
					[matTooltipTemplateContext]="{ time: time }"
					[ngClass]="{
            '!bg-red-500 disabled:!bg-red-500/60 text-white': time,
            '!bg-green-600 disabled:!bg-green-600/60 text-white': !time,
          }"
					mat-fab
					matTooltip
					matTooltipPosition="left"
				>
					<mat-icon *ngIf="!time; else runningTime">login</mat-icon>
					<ng-template #runningTime> <mat-icon>logout</mat-icon> </ng-template>
				</button>
				<!-- <div
					class="mbg-tooltip absolute bottom-0 right-full mr-2 block min-w-48 rounded px-2.5 py-2 text-left shadow"
					*ngIf="time && !time.end"
					class="mbg-tooltip absolute bottom-0 right-full mr-2 block min-w-48 rounded px-2.5 py-2 text-left shadow"
				>
					<ng-container *ngTemplateOutlet="tooltipCounter; context: { time: time }"></ng-container>
				</div> -->
			</div>
		</ng-container>
	</ng-template>
	<ng-template
		#loadingFab
		let-time="time"
	>
		<button
			disabled
			mat-fab
		>
			<mat-progress-spinner
				[diameter]="20"
				[mode]="'indeterminate'"
				[strokeWidth]="3"
				color="accent"
			></mat-progress-spinner>
		</button>
	</ng-template>
</div>
<ng-template
	#tooltipCounter
	let-time="time"
>
	<ng-container *ngIf="time && !time.end; else tooltipRecordAction">
		<div class="flex items-center gap-2">
			<span class="font-bold align-middle">{{ 'comego.widget.checkout' | translate }}</span>
		</div>
	</ng-container>
	<ng-template #tooltipRecordAction>{{ 'comego.widget.start' | translate }}</ng-template>
</ng-template>
<ng-template
	#tooltipContinueRecording
	let-time="time"
	let-type="type"
>
	<ng-container *ngIf="time && !time.end; else tooltipRecordAction">
		<div class="flex flex-row items-center justify-start gap-2">
			<div class="flex flex-col">
				<span class="font-bold">{{
					(type === 'work' ? 'comego.state.pause' : 'comego.state.resume') | translate
				}}</span>
			</div>
		</div>
	</ng-container>
	<ng-template #tooltipRecordAction>{{ 'comego.widget.start' | translate }}</ng-template>
</ng-template>

<ng-template
	#confirmDeleteDialog
	let-data
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDiscard' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDisacrd' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.discard' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
